function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#DD628E"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.584 18.3188L33.5844 18.3191C34.0024 18.737 34.3341 19.2332 34.5604 19.7793C34.7866 20.3254 34.9031 20.9107 34.9031 21.5018C34.9031 22.0929 34.7866 22.6783 34.5604 23.2244C34.3341 23.7705 34.0024 24.2667 33.5844 24.6846L33.5842 24.6847L32.5242 25.7447L25.4513 32.8176L18.3784 25.7447L17.3184 24.6847C16.4742 23.8406 16 22.6956 16 21.5018C16 20.308 16.4742 19.1631 17.3184 18.3189C18.1626 17.4748 19.3075 17.0005 20.5013 17.0005C21.6951 17.0005 22.84 17.4748 23.6842 18.3189L24.7442 19.3789C25.1347 19.7695 25.7679 19.7695 26.1584 19.3789L27.2184 18.3189L27.2186 18.3188C27.6365 17.9007 28.1326 17.569 28.6787 17.3427C29.2248 17.1165 29.8102 17 30.4013 17C30.9924 17 31.5777 17.1165 32.1239 17.3427C32.67 17.569 33.1661 17.9007 33.584 18.3188Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgGeneralMaritalStatus = function SvgGeneralMaritalStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneralMaritalStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general_maritalStatus.5a4eac2a.svg";
export { ForwardRef as ReactComponent };